<template>
  <v-dialog v-model="dialog" persistent max-width="440px">
    <v-card class="delete-dialog-card">

      <!-- Header -->
      <v-card-title class="delete-dialog__header pa-6 pb-4">
        <span class="delete-dialog__title">Apagar sessão</span>
        <v-btn icon small @click="dialog = false" class="delete-dialog__close">
          <v-icon size="20" color="#8c8a97">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-6 pt-0">

        <!-- Ícone de aviso -->
        <div class="delete-dialog__icon-wrapper mb-5">
          <div class="delete-dialog__icon-circle">
            <v-icon size="32" color="#ff4d4d">mdi-delete-outline</v-icon>
          </div>
        </div>

        <!-- Mensagem -->
        <p class="delete-dialog__desc mb-6">
          Tem certeza que deseja apagar essa sessão?
          <br />
          <span class="delete-dialog__desc--warning">Essa ação não pode ser desfeita.</span>
        </p>

        <!-- Opções -->
        <div class="delete-dialog__options">
          <div v-if="isFromGroup" class="delete-dialog__option">
            <div class="delete-dialog__option-label">
              <v-icon size="18" color="#907ff5" class="mr-2">mdi-calendar-blank-multiple</v-icon>
              <span>Apagar também as sessões futuras deste pacote</span>
            </div>
            <v-switch
              v-model="form.delete_sessions"
              :true-value="1"
              :false-value="0"
              hide-details
              color="#907ff5"
              inset
              class="delete-dialog__switch mt-0 pt-0"
            />
          </div>

          <div v-if="!isCustomEvent && canDeleteTransactions" class="delete-dialog__option">
            <div class="delete-dialog__option-label">
              <v-icon size="18" color="#907ff5" class="mr-2">mdi-currency-usd</v-icon>
              <span>Apagar também os registros financeiros</span>
            </div>
            <v-switch
              v-model="form.delete_transactions"
              :true-value="1"
              :false-value="0"
              hide-details
              color="#907ff5"
              inset
              class="delete-dialog__switch mt-0 pt-0"
            />
          </div>
        </div>

      </v-card-text>

      <!-- Ações -->
      <v-card-actions class="delete-dialog__actions pa-6 pt-2">
        <button class="delete-dialog__btn delete-dialog__btn--cancel" @click="dialog = false">
          Cancelar
        </button>
        <button class="delete-dialog__btn delete-dialog__btn--delete" @click="handleDelete()">
          <v-icon size="16" color="#fff" class="mr-1">mdi-delete</v-icon>
          Apagar
        </button>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    session: {},
  },

  data: () => ({
    dialog: false,

    form: {
      delete_sessions: 0,
      delete_transactions: 0,
    },
  }),

  computed: {
    isFromGroup() {
      return this.session.session_group.repetitions_count > 1;
    },

    isTransactionFromFormGroup() {
      return this.session.transactions.length == 0;
    },

    canDeleteTransactions() {
      if (this.isTransactionFromFormGroup) {
        return this.form.delete_sessions;
      }

      return true;
    },

    isCustomEvent() {
      return this.session.session_group.session_type == 'custom_event';
    },
  },

  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },

    reset() {
      this.form.delete_sessions = 0;
      this.form.delete_transactions = 0;
    },

    async handleDelete() {
      this.$loading.start();
      await this.$http
        .destroy("sessions/session", this.session.id, this.form)
        .then(() => {
          this.$loading.finish();
          this.$emit("delete");
          this.dialog = false;
        })
        .catch(() => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style scoped>
.delete-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}

/* Header */
.delete-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delete-dialog__title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: #33303e;
}

.delete-dialog__close {
  margin-left: auto;
}

/* Ícone */
.delete-dialog__icon-wrapper {
  display: flex;
  justify-content: center;
}

.delete-dialog__icon-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #fff1f1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mensagem */
.delete-dialog__desc {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #4e4b59;
  text-align: center;
}

.delete-dialog__desc--warning {
  font-weight: 600;
  color: #8c8a97;
}

/* Opções */
.delete-dialog__options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.delete-dialog__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  background: #f8f7ff;
  border: 1.5px solid #ebebf5;
}

.delete-dialog__option-label {
  display: flex;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #4e4b59;
  flex: 1;
  padding-right: 8px;
}

.delete-dialog__switch {
  flex-shrink: 0;
}

/* Ações */
.delete-dialog__actions {
  display: flex;
  gap: 12px;
}

.delete-dialog__btn {
  flex: 1;
  height: 38px;
  border-radius: 100px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-dialog__btn--cancel {
  background: transparent;
  border: 1.5px solid #d1cee0;
  color: #33303e;
}

.delete-dialog__btn--cancel:hover {
  background: #f4f4fb;
}

.delete-dialog__btn--delete {
  background: #ff4d4d;
  border: none;
  color: #fff;
}

.delete-dialog__btn--delete:hover {
  opacity: 0.9;
}

</style>
